import * as React from 'react';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { IconButton, Stack } from '@mui/material';
import ControlCameraIcon from '@mui/icons-material/ControlCamera';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DescriptionIcon from '@mui/icons-material/Description';
import commonApiService from '../services/commonApiService';
import DrillDownTripIcon from '../utils/DrillDownTripIcon';
import ShippingBookingIcon from '../utils/ShippingBookingIcon';
import PartialTripIcon from '../utils/PartialTripIcon';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { baseUrl } from '../services/commonUrlConsts/commonUrlConsts';

let apiService = commonApiService();

export const ActionCell = ({ ...props }) => {
    const LightTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }}  />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.neutral.main,
        color: 'rgba(255, 255, 225, 0.99)',
        boxShadow: theme.shadows[10],
        fontSize: 14,
        paddingLeft: 25,
        paddingRight: 25,
        },
    }));

    const onIconClick = async (urlParam) => {
        try {
            const apiUrl = `${baseUrl}/${props.gridFlagVal === 'ptmovements'? "movements":props.gridFlagVal}(${props.dataId})/Microsoft.NAV.${urlParam}`;
            apiService.post(apiUrl, {}).then((res)=>{
                if(res.value) {
                    window.open(res.value, '_blank');
                    return;
                } else {
                    props?.setErrorParameterAndMessage(res.error.message)
                }
            })
        } catch (error) {
            console.error('Error in onIconClick:', error);
        }
    };

    return (
        <Stack spacing={.3} direction="row">
            {
                props.gridFlagVal == "partialTrips" && (
                    <Tooltip placement="top" title="Drill Down Trip">
                        <IconButton onClick={() => onIconClick("getUrlTrip")} sx={{ background: 'white', p: 0.3 }} size="small" color="primary">
                            <DrillDownTripIcon sx={{ padding: '0px 0px' }} />
                        </IconButton>
                    </Tooltip>
                )
            }
            <Tooltip placement="top" title={`Drill Down ${(props.gridFlagVal == "movements" || props.gridFlagVal == 'ptmovements') ? "Movement" : "Partial Trip"}`}>
                <IconButton onClick={() => onIconClick((props.gridFlagVal == "movements" || props.gridFlagVal == 'ptmovements') ? "getUrlMovement" : "getUrlPartialTrip")} sx={{ background: 'white', p: 0.3 }} size="small" color="primary">
                    {props.gridFlagVal == "partialTrips" && <PartialTripIcon sx={{ padding: '0px 0px' }} />}
                    {(props.gridFlagVal == "movements" || props.gridFlagVal == 'ptmovements') && <ControlCameraIcon sx={{ padding: '0px 0px' }} />}
                </IconButton>
            </Tooltip>
            <Tooltip placement="top" title="Drill Down Shipment">
                <IconButton onClick={() => onIconClick("getUrlShipment")} sx={{ background: 'white', p: 0.3 }} size="small" color="primary">
                <LocalShippingIcon sx={{ padding: '0px 0px' }} />
                </IconButton>
            </Tooltip>
            <Tooltip placement="top" title="Drill Down File" sx={{background:'red'}}>
                <IconButton onClick={() => onIconClick("getUrlFileTpt")} sx={{ background: 'white', p: 0.3 }} size="small" color="primary">
                <DescriptionIcon sx={{ padding: '0px 0px' }} />
                </IconButton>
            </Tooltip>
            {
                (props.gridFlagVal == "movements" && 
                    <>
                        <Tooltip placement="top" title="Drill Down Shipping Booking">
                            <IconButton onClick={() => onIconClick("getUrlShippingBooking")} sx={{ background: 'white', p: 0.3 }} size="small" color="primary">
                                <ShippingBookingIcon sx={{ padding: '0px 0px' }} />
                            </IconButton>
                        </Tooltip>
                        { (props.dataStatus?.toLowerCase() == "planned" || props.dataStatus?.toLowerCase() == "in execution" || props.dataStatus?.toLowerCase() == "executed" || props.dataStatus?.toLowerCase() == "not executed") && 
                        <>
                            <Tooltip placement="top" title="Drill Down Partial Trip">
                                <IconButton onClick={() => onIconClick("getUrlPartialTrip")} sx={{ background: 'white', p: 0.3 }} size="small" color="primary">
                                    <PartialTripIcon sx={{ padding: '0px 0px' }} />
                                </IconButton>
                            </Tooltip>
                            <Tooltip placement="top" title="Drill Down Trip">
                                <IconButton onClick={() => onIconClick("getUrlTrip")} sx={{ background: 'white', p: 0.3 }} size="small" color="primary">
                                    <DrillDownTripIcon sx={{ padding: '0px 0px' }} />
                                </IconButton>
                            </Tooltip>
                        </>
                        }
                    </>
                )
            }
            {
                (props?.gridFlagVal == "partialTrips" &&
                    <Tooltip placement="top" title="Drill Down Resource">
                        <IconButton onClick={() => onIconClick("resources")} sx={{ background: 'white', p: 0.3 }} size="small" color="primary">
                            <ManageAccountsIcon sx={{ padding: '0px 0px' }} />
                        </IconButton>
                    </Tooltip>
                )
            }
        </Stack>
    );
};